import objectPath from 'object-path'
import { MATH_SYMBOLS } from '../system/menu/condition/component/calculate/config'

export const getCalculateValue = (
  formula,
  formulaValue,
  { dataValue = {}, rowData = {}, formData = {} }
) => {
  let { data = [], symbol } = formula
  data.forEach((item, dataIndex) => {
    let nextValue = 0
    let { isElement, isCustom, isSymbol, isFormula, isTable, isScore } =
      item || {}
    if (isSymbol) {
      nextValue = getCalculateValue(item, nextValue, { dataValue, formData })
    } else if (isFormula) {
      nextValue = getCalculateValue(item, nextValue, { dataValue, formData })
    } else if (isElement) {
      let { key, name } = item
      nextValue =
        objectPath.get(formData, key) || objectPath.get(formData, name)
    } else if (isCustom) {
      nextValue = item.value
    } else if (isTable) {
      let { key } = item
      nextValue = objectPath.get(rowData, key)
    } else if (isScore) {
      let { name } = item
      nextValue = objectPath.get(dataValue, name)
    }
    if (!nextValue) {
      nextValue = 0
    }
    if (dataIndex === 0) {
      formulaValue = nextValue
    } else {
      let nextSymbol = objectPath.get(symbol, dataIndex - 1)
      let foundSymbol = MATH_SYMBOLS.find((math) => math.symbol === nextSymbol)
      if (foundSymbol) {
        let { calculate } = foundSymbol
        formulaValue = calculate(formulaValue, nextValue)
      }
    }
  })
  return formulaValue
}

export const updateCalculate = ({ dataValue, formData }, foundFormula) => {
  let result = 0
  let formulaData = foundFormula?.data
  let formulaLink = foundFormula?.symbol
  if (formulaData) {
    formulaData.forEach((formula, formulaIndex) => {
      let formulaValue = 0
      formulaValue = getCalculateValue(formula, formulaValue, {
        dataValue,
        formData,
      })
      if (formulaIndex === 0) {
        result = formulaValue
      } else {
        let symbol = objectPath.get(formulaLink, formulaIndex - 1)
        let foundSymbol = MATH_SYMBOLS.find((math) => math.symbol === symbol)
        if (foundSymbol) {
          let { calculate } = foundSymbol
          result = calculate(result, formulaValue)
        }
      }
    })
  }
  return Math.round(result * 100) / 100
}

export const calculateValue = ({ dataValue, setting, formData }) => {
  let { formula } = setting
  let calculateKey = setting.calculate
  let foundFormula = formula.find(({ key }) => key === calculateKey)
  if (foundFormula) {
    return updateCalculate({ dataValue, formData }, foundFormula)
  }
  return ''
}
